import { usePathname } from '../../../routes/hooks';
import { Box, Collapse, ListItemButton, Stack, Typography } from '@mui/material';
import { RouterLink } from '../../../routes/components';
import navConfig from '../config-navigation';
import { alpha } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import { UserInfoModel } from '../../../pages/user/models/user.model';
// import { RoleChecker } from '../../../utils/role-check-utils';
export interface NavItemProps {
  onPressed: Function;
  user: UserInfoModel | null;
}
const MenuItem = (props: NavItemProps) => {
  return (
    <Stack component="nav" spacing={0.5} sx={{ mt: 2 }}>
      {navConfig.map((item: any, index: number) => (
        <NavItem key={index} item={item} onPressed={() => props.onPressed()} />
      ))}
    </Stack>
  );
};

export const NavItem = ({
  item,
  isChild,
  onPressed,
}: {
  item: any;
  isChild?: boolean;
  onPressed: Function;
}) => {
  const pathname = usePathname();
  const active = item.path === pathname;
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (pathname !== '/' && item?.child) {
      const isOpened = item?.child?.some((itm: any) => itm?.path && itm.path.includes(pathname));
      if (isOpened || pathname.includes(item.path)) {
        setOpen(true);
      }
    }
  }, [active]);
  return (
    <div style={{ marginLeft: isChild ? '18px' : '0px' }} key={item?.path}>
      <ListItemButton
        onClick={() => {
          if (item?.child) {
            setOpen(!open);
          } else {
            onPressed();
          }
        }}
        component={RouterLink}
        href={item?.child ? null : item?.path}
        sx={{
          flexDirection: 'row',
          minHeight: 44,
          borderRadius: 5,
          typography: 'body2',
          textTransform: 'capitalize',
          fontWeight: 'fontWeightMedium',
          color: '#5A5A5A',
          ...(active && {
            color: '#EEEFF3',
            fontWeight: 'fontWeightSemiBold',
            bgcolor: (theme) => alpha(theme.palette.primary.main, 1),
            '&:hover': { bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16) },
          }),
        }}
      >
        {item.icon !== '' && (
          <Box component="span" sx={{ width: isChild ? 18 : 24, height: isChild ? 18 : 24, mr: 2 }}>
            {item.icon}
          </Box>
        )}
        <Box display={'flex'} flexDirection={'row'} flex={1}>
          <Typography sx={{ maxLines: 1, flex: 1 }}>{item.title}</Typography>
        </Box>
        {item?.child ? open ? <ExpandLessRoundedIcon /> : <ExpandMoreRoundedIcon /> : null}
      </ListItemButton>
      <Collapse unmountOnExit={true} orientation={'vertical'} in={open}>
        {item?.child?.map((itm: any, indx: number) => (
          <NavItem key={indx} item={itm} isChild={true} onPressed={() => onPressed()} />
        ))}
      </Collapse>
    </div>
  );
};

export default MenuItem;
